import { SubCompany } from "./types";

export const FETCH_SUB_COMPANIES = "FETCH_SUB_COMPANIES";
export const FETCH_SUB_COMPANIES_SUCCESS = "FETCH_SUB_COMPANIES_SUCCESS";
export const FETCH_SUB_COMPANIES_FAILURE = "FETCH_SUB_COMPANIES_FAILURE";

export const fetchSubCompanies = (partnerId: string | number) => ({
  type: FETCH_SUB_COMPANIES,
  payload: partnerId,
});

export const fetchSubCompaniesSuccess = (companies: SubCompany[]) => ({
  type: FETCH_SUB_COMPANIES_SUCCESS,
  payload: companies,
});

export const fetchSubCompaniesFailure = (error: any) => ({
  type: FETCH_SUB_COMPANIES_FAILURE,
  payload: error,
});
